import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBZBfDPRc8CwQ-82IUhQqYHbzI1Namub98",
  authDomain: "fantasy-ipl-ecb85.firebaseapp.com",
  databaseURL: "https://fantasy-ipl-ecb85-default-rtdb.firebaseio.com",
  projectId: "fantasy-ipl-ecb85",
  storageBucket: "fantasy-ipl-ecb85.firebasestorage.app",
  messagingSenderId: "170524014385",
  appId: "1:170524014385:web:f09fbe65faaa65b5216210"
};

const app = initializeApp(firebaseConfig);

export const db      = getDatabase(app);
export const auth    = getAuth(app);
export const storage = getStorage(app);